import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.storeJobsWithRequest4Change.length > 0)?_c('div',[_c('div',{staticClass:"req4change mr-1",on:{"click":function($event){return _vm.req4changeClick()}}},[_c(VBtn,{attrs:{"color":"yellow","fab":"","x-small":""}},[_vm._v(" "+_vm._s(_vm.storeJobsWithRequest4Change.length)+" ")]),_c('p',{staticClass:"text ml-2"},[_vm._v("Requested for change")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }